import React, { useCallback } from 'react'
import * as Yup from 'yup'

import * as TtForms from '@23/react-forms'
import { TtButton } from '@23/ui-react'

import './ToolbarLinkPanel.scss'

const schema = Yup.object({
  url: Yup.string().url('Invalid URL format').required('URL is required'),
})

type FormValues = Yup.InferType<typeof schema>

interface ToolbarLinkPanelProps {
  initialUrl: string
  isExistingLink: boolean
  onConfirm: (url: string) => void
  onUnlink: () => void
  onCancel: () => void
}

const ToolbarLinkPanel = ({
  initialUrl,
  isExistingLink,
  onConfirm,
  onUnlink,
  onCancel,
}: ToolbarLinkPanelProps) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
  }

  const handleSubmit = useCallback(
    (values: FormValues) => {
      onConfirm(values.url)
    },
    [onConfirm]
  )

  return (
    <TtForms.Form<FormValues>
      initialValues={{
        url: initialUrl,
      }}
      enableReinitialize
      validationSchema={schema}
      onSubmit={handleSubmit}
      className="description-toolbar-link-form"
    >
      <TtForms.TextField
        name="url"
        label="Link URL"
        hideLabel
        placeholder="https://"
      />

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className="description-toolbar-link-actions"
        onMouseDown={handleMouseDown}
      >
        <TtButton
          color="secondary"
          variant="light"
          onClick={onCancel}
          size="small"
        >
          Cancel
        </TtButton>
        {isExistingLink && (
          <TtButton color="danger" onClick={onUnlink} size="small">
            Remove
          </TtButton>
        )}
        <TtForms.SubmitButton size="small">Apply</TtForms.SubmitButton>
      </div>
    </TtForms.Form>
  )
}

export { ToolbarLinkPanel }
